module.exports = __webpack_public_path__ + "media/images/aloe/logo/nephos-gold-8cadb760afed2d63599223d0b49e407e.svg";